import { useTranslation } from 'react-i18next'

import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import Text from '../../Text'
import { DashboardListRow } from '../DashboardListRow'

// TODO Presence (Online / Offline) has no data source yet (OD-06): add the
// Status subtitle once it ships.
function BirdviewTeamMemberRow({ item, onOpen }) {
  const { t } = useTranslation()

  function handleOpen() {
    onOpen(item)
  }

  return (
    <DashboardListRow
      Before={Avatar}
      Meta={Text}
      beforeProps={{ ...item.avatarProps, size: AVATAR_HEIGHT_24 }}
      metaProps={{
        children: t('DashboardBirdview.TeamLoadMetaKey', {
          open: item.open,
          overdue: item.overdue,
        }),
        isSecondary: true,
      }}
      title={item.title}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewTeamMemberRow
